import { Component, forwardRef } from '@angular/core';
import { RadioRowV2Option, RadioV2Module, DateV2Module } from '@schenck/rotec-components';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Scheduling, TaskIntervalPattern } from 'src/api';
import { startOfDay } from 'date-fns';
import { TranslateDirective } from '@ngx-translate/core';
import { SchedulingIntervalComponent } from './scheduling-interval/scheduling-interval.component';

export type SchedulingModel =
  | {
      single: true;
      dueDate: Date;
    }
  | {
      single: false;
      scheduling: Scheduling;
    };

@Component({
  selector: 'ma-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.less'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SchedulingComponent), multi: true },
  ],
  imports: [RadioV2Module, TranslateDirective, DateV2Module, SchedulingIntervalComponent],
})
export class SchedulingComponent implements ControlValueAccessor {
  public schedulingOptions: RadioRowV2Option[] = [
    { value: false, name: 'Serial Task' },
    { value: true, name: 'Once' },
  ];
  public minDate = startOfDay(new Date());
  public dueDate: Date = startOfDay(new Date());
  public scheduling: Scheduling = {
    pattern: TaskIntervalPattern.Daily,
    appearance: null,
    dayOfMonth: null,
    endDate: null,
    interval: 1,
    month: null,
    startDate: startOfDay(new Date()),
    weekDays: null,
  };
  public model: SchedulingModel = { single: false, scheduling: this.scheduling };

  public changeScheduling(scheduling: Scheduling): void {
    this.scheduling = scheduling;
    this.model = { single: false, scheduling };
    this.modelChanged(this.model);
  }

  public changeDueDate(dueDate: Date): void {
    this.dueDate = dueDate;
    this.model = { single: true, dueDate };
    this.modelChanged(this.model);
  }

  public changeSchedulingType(single: boolean): void {
    this.model = single
      ? { single: true, dueDate: this.dueDate }
      : { single: false, scheduling: this.scheduling };
    this.modelChanged(this.model);
  }

  public writeValue(obj: any): void {
    if (!obj) {
      // Add default value to form if no value set.
      setTimeout(() => {
        this.modelChanged(this.model);
      });
      return;
    }

    this.model = obj;
    if (this.model.single === false) {
      this.scheduling = this.model.scheduling;
    } else {
      this.dueDate = this.model.dueDate;
    }
  }

  public modelChanged = (model: SchedulingModel) => {};

  public registerOnChange(fn: any): void {
    this.modelChanged = (val: any) => {
      fn(val);
    };
  }

  public touched = () => {};

  public registerOnTouched(fn: any): void {
    this.touched = fn;
  }
}
